export class SocketModel {
  static INCOMING_MESSAGE = 'IncomingMessage';
  static BROADCAST = 'broadcast';
  static NOTES_UPDATED = 'NOTES_UPDATED';

  message: string;
  payload: object;

  constructor(message: string, payload: object) {
    this.message = message;
    this.payload = payload;
  }
}
